// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"hpr9uKvoD7JEvWfc2PRI"};